import React, { useMemo } from 'react';
import { translate } from '@utils/i18n';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import ErrorComponent from '@components/Error';
import { Modal } from '@components/v2/Modal';
import { Button } from '@ui';
import Form from './form';
import useEasyUploadLinkModalContext from '../context/useEasyUploadLinkModalContext';
function EasyUploadLinkModal() {
    const namespace = 'features.modals.easy_upload_link_modal';
    const { easyUploadLink, modalReady, modalError, closeModal } = useEasyUploadLinkModalContext();
    const header = useMemo(() => {
        if (!easyUploadLink || !modalReady) {
            return React.createElement("b", null, translate('loading', { namespace: 'features.commons' }));
        }
        return React.createElement("b", null, translate('easy_upload_link', { namespace }));
    }, [easyUploadLink, modalReady]);
    const content = useMemo(() => {
        if (modalError)
            return React.createElement(ErrorComponent, { error: modalError });
        if (modalReady)
            return React.createElement(Form, null);
        return (React.createElement("div", { style: { height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.6rem' } },
            React.createElement(Loader, { size: LoaderSizes.large })));
    }, [modalReady, modalError]);
    return (React.createElement(Modal, { onClose: closeModal, title: header, width: "360px", isOpen: true, className: "easyUploadLinkModal", footer: React.createElement(Button, { onClick: closeModal }, translate('close', { namespace: 'features.commons' })) }, content));
}
export default EasyUploadLinkModal;
